"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Token = exports.TokenType = void 0;
var TokenType;
(function (TokenType) {
    TokenType["Call"] = "Call";
    TokenType["PureValue"] = "PureValue";
    TokenType["Value"] = "Value";
    TokenType["And"] = "And";
    TokenType["Comma"] = "Comma";
    TokenType["Number"] = "Number";
    TokenType["String"] = "String";
    TokenType["Less"] = "Less";
    TokenType["LessEqual"] = "LessEqual";
    TokenType["Greater"] = "Greater";
    TokenType["GreaterEqual"] = "GreaterEqual";
    TokenType["Equal"] = "Equal";
    TokenType["NotEqual"] = "NotEqual";
    TokenType["Add"] = "Add";
    TokenType["Minus"] = "Minus";
    TokenType["Times"] = "Times";
    TokenType["Mod"] = "Mod";
    TokenType["Div"] = "Div";
    TokenType["Concat"] = "Concat";
    TokenType["Or"] = "Or";
    TokenType["Not"] = "Not";
    TokenType["LeftParen"] = "LeftParen";
    TokenType["RightParen"] = "RightParen";
    TokenType["Blank"] = "Blank";
    TokenType["Unknown"] = "Unknown";
})(TokenType = exports.TokenType || (exports.TokenType = {}));
class Token {
    constructor(type, index, value) {
        this.type = type;
        this.index = index;
        this.value = value;
        // String and Value need to remove quotes and braces
        this.value = value;
    }
    toString() {
        return `${this.type}::${this.value}`;
    }
}
exports.Token = Token;
//# sourceMappingURL=token.js.map